export default __webpack_public_path__ + "static/media/ai-guild-badge.421d1871.png";